export const CART_LOCAL_STORAGE_NAME = 'whoop-cartId';
